"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SendEmailConfirm = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _state = require("../../../../state");
var _TimerTextButton = require("../../../TimerTextButton");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledTimerTextButton = (0, _styledComponents.default)(_TimerTextButton.TimerTextButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 10px;\n"])));
var SendEmailConfirm = function SendEmailConfirm() {
  var _useTranslation = (0, _reactI18next.useTranslation)('libSettings'),
    t = _useTranslation.t;
  var _useSendEmailConfirm = (0, _state.useSendEmailConfirm)(),
    sendConfirmEmail = _useSendEmailConfirm.sendConfirmEmail,
    sendConfirmEmailState = _useSendEmailConfirm.sendConfirmEmailState;
  return /*#__PURE__*/_react.default.createElement(StyledTimerTextButton, {
    afterTimeoutClick: sendConfirmEmail,
    timeout: sendConfirmEmailState.remainingTime,
    label: t('confirmEmail'),
    loading: sendConfirmEmailState.loading
  });
};
exports.SendEmailConfirm = SendEmailConfirm;